/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MOTOLYNK MARKET API
 * Admin, vendor and store APIs of the MOTOLYNK multi-vendor marketplace.
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `manual` - Manual
 * * `automatic` - Automatic
 * * `amt` - AMT
 * * `cvt` - CVT
 * * `dct` - DCT
 */
export type TransmissionEnum = typeof TransmissionEnum[keyof typeof TransmissionEnum];


export const TransmissionEnum = {
  manual: 'manual',
  automatic: 'automatic',
  amt: 'amt',
  cvt: 'cvt',
  dct: 'dct',
} as const;
